(() => {
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-faq-more]');
    if (!button) return;
    const list = button.closest('[data-approved-faq]');
    const expanded = button.getAttribute('aria-expanded') !== 'true';
    list.querySelectorAll('[data-faq-extra]').forEach(item => {
      item.hidden = !expanded;
      if (!expanded) item.open = false;
    });
    button.setAttribute('aria-expanded', String(expanded));
    button.querySelector('[data-faq-more-label]').textContent = expanded ? 'Less' : 'More';
  });
})();
